/**
 * Словарь тегов фидбека Block 10 «Что улучшить в сервисе?» (PRD §14).
 *
 * 6 тегов, мульти-выбор. Тег `'other'` открывает дополнительное text input
 * (см. ADR-0018 §Q1 — `FeedbackScreenImprovementSchema.superRefine` на `customTag`).
 *
 * Russian human-readable name по B-074 ARIA pattern (Block 4 KindPicker как ref).
 * Russian-only на текущем этапе; KZ/UZ — Phase 9+ при подключении LinguiJS.
 *
 * References:
 *   - ADR-0018 §Q2 «Vocabulary FeedbackTagSchema»
 *   - PRD `docs/prd/v4/14-block-10-feedback.md` §«Экран 2.10.1»
 *   - Reference pattern: `domain/configurator-vocabularies.ts` (FurnitureType + labels)
 */

export const FEEDBACK_TAGS = ['decors', 'hardware', 'shops', 'calculator', 'ui', 'other'] as const;

export type FeedbackTag = (typeof FEEDBACK_TAGS)[number];

/**
 * Русские лейблы для UI (Экран 2.10.1, чипы тегов).
 * Источник истины — здесь; LinguiJS-локализация UZ/KZ — отдельная фаза.
 */
export const FEEDBACK_TAG_LABELS: Record<FeedbackTag, string> = {
  decors: 'Декоры',
  hardware: 'Фурнитура',
  shops: 'Магазины',
  calculator: 'Калькулятор',
  ui: 'Интерфейс',
  other: 'Другое',
};

/** Type guard: проверяет, что произвольное значение — валидный `FeedbackTag`. */
export function isFeedbackTag(value: unknown): value is FeedbackTag {
  return typeof value === 'string' && (FEEDBACK_TAGS as readonly string[]).includes(value);
}
